import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Trash2, ShoppingBag } from 'lucide-react';
import { toast } from 'sonner';

const Cart = () => {
  const { cart, removeFromCart } = useCart();

  const handleRemove = (ebookId) => {
    removeFromCart(ebookId);
    toast.success('Item removido do carrinho');
  };

  const getPaymentLink = (ebookId) => {
    const paymentLinks = {
      1: 'https://pag.ae/814_gjQsH',  // Treinamento de Hipertrofia Masculino
      2: 'https://pag.ae/7_ZymgpcK',  // Treinamento de Glúteos e Coxas Feminino
      3: 'https://pag.ae/815yQxVS3',  // Manual Completo de Treinamento de Força para Homens
      4: 'https://pag.ae/815y--TTJ',  // Manual Completo de Treinamento de Força para Mulheres
      5: 'https://pag.ae/815zbTsTH',  // Plano de Resistência de 21 Dias
      6: 'https://pag.ae/816USTk62'   // Transforme Sua Vida em 21 Dias
    };
    return paymentLinks[ebookId] || '#';
  };

  const handleCheckout = (ebookId) => {
    const link = getPaymentLink(ebookId);
    window.open(link, '_blank');
    toast.success('Você será redirecionado para o pagamento');
  };

  if (cart.length === 0) {
    return (
      <div style={{ 
        background: 'var(--bg-page)', 
        minHeight: '100vh', 
        paddingTop: '120px',
        paddingBottom: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div className="container" style={{ maxWidth: '600px', textAlign: 'center' }}>
          <ShoppingBag size={80} color="var(--text-light)" style={{ marginBottom: '24px' }} />
          <h1 className="heading-1" style={{ marginBottom: '16px' }}>
            Seu carrinho está vazio
          </h1>
          <p className="body-large" style={{ marginBottom: '32px', color: 'var(--text-secondary)' }}>
            Adicione produtos incríveis ao seu carrinho e comece sua transformação!
          </p>
          <Link to="/produtos">
            <button className="btn-primary">Ver Produtos</button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh', paddingTop: '120px', paddingBottom: '64px' }}>
      <div className="container" style={{ maxWidth: '1000px' }}>
        <h1 className="display-medium" style={{ marginBottom: '32px' }}>
          Meu Carrinho
        </h1>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '24px', marginBottom: '32px' }}>
          {cart.map(item => (
            <div key={item.id} className="network-card" style={{ 
              padding: '24px'
            }}>
              <div style={{ 
                display: 'flex',
                gap: '24px',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginBottom: '20px'
              }}>
                <img 
                  src={item.image} 
                  alt={item.title}
                  style={{ 
                    width: '150px', 
                    height: '150px', 
                    objectFit: 'cover',
                    borderRadius: '16px'
                  }}
                />
                <div style={{ flex: 1, minWidth: '250px' }}>
                  <p className="caption" style={{ color: 'var(--brand-dark)', fontWeight: '600', marginBottom: '4px' }}>
                    {item.target}
                  </p>
                  <h3 className="heading-3" style={{ marginBottom: '8px' }}>
                    {item.title}
                  </h3>
                  <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '12px' }}>
                    {item.subtitle}
                  </p>
                  <p className="heading-3" style={{ color: 'var(--brand-dark)' }}>
                    R$ {item.price.toFixed(2)}
                  </p>
                </div>
                <button
                  onClick={() => handleRemove(item.id)}
                  style={{
                    background: 'none',
                    border: '2px solid var(--border-medium)',
                    borderRadius: '50%',
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#dc2626';
                    e.currentTarget.style.background = '#fee2e2';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'var(--border-medium)';
                    e.currentTarget.style.background = 'none';
                  }}
                >
                  <Trash2 size={20} color="#dc2626" />
                </button>
              </div>
              
              {/* Botão de pagamento individual */}
              <button 
                className="btn-cta"
                onClick={() => handleCheckout(item.id)}
                style={{ 
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  marginBottom: '16px'
                }}
              >
                <ShoppingBag size={20} />
                Comprar Agora - R$ {item.price.toFixed(2)}
              </button>
              
              {/* Lembrete de envio de comprovante */}
              <div style={{
                background: '#FEF3C7',
                border: '2px solid #F59E0B',
                borderRadius: '12px',
                padding: '16px',
                textAlign: 'center'
              }}>
                <p style={{ 
                  margin: 0,
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#92400E'
                }}>
                  ⚠️ <strong>IMPORTANTE:</strong> Após a compra, enviar o comprovante para o WhatsApp <strong>(71) 99289-3333</strong> para liberar seu e-book
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Informação sobre compras múltiplas */}
        <div className="network-card" style={{ 
          padding: '24px',
          background: 'var(--bg-subtle)',
          textAlign: 'center'
        }}>
          <p className="body-medium" style={{ marginBottom: '8px' }}>
            💡 <strong>Dica:</strong> Você pode comprar cada programa separadamente
          </p>
          <p className="body-small" style={{ color: 'var(--text-light)' }}>
            Clique no botão "Comprar Agora" de cada produto para ser redirecionado ao pagamento seguro do PagSeguro
          </p>
        </div>
      </div>
    </div>
  );
};

export default Cart;